<div class="journey-popup-container">
    <div class="p-4">
        <div class="flex justify-between items-center">
            <p class="title">{{ title | translate }}</p>

            <button type="button" class="flex" (click)="onSkipJourney()">
                <mat-icon svgIcon="close" class="!text-[#817F7F] !w-[0.875rem] !h-[0.875rem]"></mat-icon>
            </button>
        </div>

        <div class="description" [innerHTML]="description | translate"></div>

        <div class="flex justify-between items-center mt-4">
            <p class="journey-list">{{ currentStep }} of {{ totalSteps }}</p>

            <div class="flex items-center justify-center">
                <button
                    type="button"
                    class="px-4 py-2 font-bold text-base text-[#C5C5C5] font-lato"
                    [hidden]="isFirstStep"
                    [ngClass]="{ '!text-[#5F5B5B]': !isFirstStep }"
                    (click)="onPrevJourney()">
                    {{ 'button.prev' | translate }}
                </button>

                <button type="button" class="btn-primary !px-4 !py-2 ml-[0.375rem] font-lato" (click)="onNextJourney()">
                    {{ (isLastStep ? 'button.done' : 'button.next') | translate }}
                </button>
            </div>
        </div>
    </div>

    <div id="journeyPointer" [class]="triangleUiClass + ' triangle-container'">
        <div class="triangle"></div>
    </div>
</div>
